














































import { Component, Vue, Prop, PropSync } from "vue-property-decorator";

@Component
class MethodsWindow extends Vue {
  @Prop() methods!: string[];

  @Prop() title!: string;

  @PropSync("method") bindMethod!: number;

  loading = false;

  handleMixinLogin() {
    this.$common.utils.helper.requestMixinLogin(this);
  }

  handleLoginViaSms() {
    this.$emit("useSms");
  }
}
export default MethodsWindow;
